import { Chakra } from "@airhelp/react-ui-components";
import { FlagBox } from "components/LanguageSwitcher";
import { useModal } from "contexts/ModalContext";
import { useDeviceSize } from "hooks";
import { TOP_MENU_LANG_MODAL_OPEN_GTM, TOP_MENU_LANG_MODAL_OPEN_MP } from "modules/common/trackingConsts";
import { AirhelpPlusLogo } from "styles/logos";
import ActionButtons from "../ActionButtons";
import MenuItems from "../MenuItems";
import MobileMenu from "../MobileMenu";
import type { HeaderNavProps } from "./HeaderNav.d";

const { Flex } = Chakra;

const Logo = ({ ...props }) => <AirhelpPlusLogo {...props} />;

const HeaderNav = ({ menuItems, buttons, showLanguageSwitcher, ...props }: HeaderNavProps) => {
  const { isDesktop } = useDeviceSize();
  // @ts-ignore
  const { openModal } = useModal();

  const FlagBoxWrapper = () => (
    <Flex flexGrow={{ base: 1, lg: 0 }} ml={{ lg: 3 }} justifyContent="flex-end">
      <FlagBox
        openModal={openModal}
        trackingEvents={{ gtmEvent: TOP_MENU_LANG_MODAL_OPEN_GTM, mixpanelEvent: TOP_MENU_LANG_MODAL_OPEN_MP }}
        // @ts-ignore
        dataQA="top-navbar-lang-switcher"
      />
    </Flex>
  );

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      px={{ base: 4, xl: 16 }}
      pb={4}
      data-testid="ah-plus-navigation"
      {...props}
    >
      <Logo w="159px" h="34px" />
      {isDesktop && <MenuItems menuItems={menuItems} />}
      {showLanguageSwitcher && <FlagBoxWrapper />}
      {isDesktop && <ActionButtons buttons={buttons} />}
      <MobileMenu menuItems={menuItems} buttons={buttons} />
    </Flex>
  );
};

export default HeaderNav;
